'use client'

import Breadcrumb from '@/components/breadcrumb'
import LinkInsights from '@/components/links/insights'
import { Article } from '@/entities/article'
import { cn } from '@utils'

export default function ArticleBreadcrumb({
  data,
  modal = false,
}: {
  data: Article
  modal?: boolean
}) {
  return (
    <section
      className={cn('mt-5', modal ? 'px-4 lg:px-7.5' : 'section-article')}
    >
      <Breadcrumb
        home
        items={[
          <LinkInsights key='insights' native={modal}>
            Insights
          </LinkInsights>,
        ]}
      >
        {data.subject}
      </Breadcrumb>
    </section>
  )
}
